/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  Expression,
  Icon,
  LocalizedString128,
  LocalizedString256,
  SiteExternalLink,
  SiteSectionDescription,
  SiteSectionTitle,
  URL,
} from "./data-contracts";

/**
 * @description Creates an external navigation link at the site root or in a section group. On a site with root variants and no sections, creating the first external link enables sections and moves those variants into a default section. Links cannot be placed inside a section. The destination must be an absolute HTTP or HTTPS URL. Draft links and links whose adaptive condition does not match are omitted from published structure responses. Use the generic structure sort operation after creation to change sibling order.
 * @tags site-external-links
 * @name AddExternalLinkToSite
 * @summary Add an external link to a site's navigation
 * @request POST:/orgs/{organizationId}/sites/{siteId}/external-links
 * @secure
 */

// @ts-ignore
export const addExternalLinkToSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site section */
    title: SiteSectionTitle;
    /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
    localizedTitle?: LocalizedString128;
    description?: SiteSectionDescription | null;
    localizedDescription?: LocalizedString256 | null;
    icon?: Icon | null;
    /** Absolute HTTP or HTTPS destination URL */
    url: URL;
    /** ID of the section group to create the link in. Omit to place it at the site root. */
    parent?: string;
    /** Whether the external link should be created in draft mode */
    draft?: boolean;
    /** Adaptive condition controlling whether visitors see the link */
    condition?: Expression | null;
  };
  RequestHeaders: {};
  ResponseBody: SiteExternalLink;
  ResponseStatusCode: 201 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/external-links",
  method: "post",
  streaming: false,
  tags: ["site-external-links"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates an external navigation link. Set parent to a section group ID to move the link into that group, or null to move it to the site root; links cannot be placed inside a section. A changed destination must remain an absolute HTTP or HTTPS URL. Draft and adaptive-condition fields control visibility. Use the generic structure sort operation after changing the parent to adjust the link's sibling order.
 * @tags site-external-links
 * @name UpdateSiteExternalLinkById
 * @summary Update an external link in a site's navigation
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/external-links/{siteExternalLinkId}
 * @secure
 */

// @ts-ignore
export const updateSiteExternalLinkById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the site external link */
    siteExternalLinkId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site section */
    title?: SiteSectionTitle;
    localizedTitle?: LocalizedString128 | null;
    description?: SiteSectionDescription | null;
    localizedDescription?: LocalizedString256 | null;
    icon?: Icon | null;
    /** Absolute HTTP or HTTPS destination URL */
    url?: URL;
    /** ID of the section group to move the link into. Set to null to move it to the site root. */
    parent?: string | null;
    /** Whether the external link should be kept in draft mode */
    draft?: boolean;
    /** Adaptive condition controlling whether visitors see the link */
    condition?: Expression | null;
  };
  RequestHeaders: {
    /** Control whether a successful response includes the updated resource representation. */
    prefer?: "return=minimal" | "return=representation";
  };
  ResponseBody: SiteExternalLink | undefined;
  ResponseStatusCode: 200 | 204 | 400 | 404;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/external-links/{siteExternalLinkId}",
  method: "patch",
  streaming: false,
  tags: ["site-external-links"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Deletes an external link. This operation is intentionally unavailable to MCP clients.
 * @tags site-external-links
 * @name DeleteSiteExternalLinkById
 * @summary Delete an external link from a site's navigation
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/external-links/{siteExternalLinkId}
 * @secure
 */

// @ts-ignore
export const deleteSiteExternalLinkById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the site external link */
    siteExternalLinkId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205 | 404;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/external-links/{siteExternalLinkId}",
  method: "delete",
  streaming: false,
  tags: ["site-external-links"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
